// =================================================================
// Engine: Level draw-time correction (PSD §4.2.10 / TODO Task 2.2)
// =================================================================
import { err, ok } from './types';
/**
 * Correct a measured level for actual vs target draw time (PSD §4.2.10).
 * corrected = measured × e^(kel × deltaHr). Flag if |deltaHr| > 2h.
 */
export function correctLevelForDrawTime(measuredValue, actualOffsetMin, targetOffsetMin, kelPerHr) {
    if (!(measuredValue > 0)) {
        return err('level-must-be-positive', 'Measured value must be positive.', 'measuredValue');
    }
    if (!(kelPerHr > 0)) {
        return err('kel-must-be-positive', 'Kel must be positive for correction.', 'kelPerHr');
    }
    const deltaHr = (targetOffsetMin - actualOffsetMin) / 60;
    const correctedValue = measuredValue * Math.exp(kelPerHr * deltaHr);
    return ok({ correctedValue, largeDelta: Math.abs(deltaHr) > 2 });
}
//# sourceMappingURL=levelCorrection.js.map